import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaSearchContextInterface } from '../schema/search-context.interface';
import { Snowplow2StatsAdapterCategory } from './category';
import { Snowplow2StatsAdapterFurnishings } from './furnishings';
import { Snowplow2StatsAdapterPricePeriod } from './price-period';

export class Snowplow2StatsAdapterSchemaSearchContext implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaSearchContextInterface {
    if (!this.context.global.property_search) {
      throw new Error('Stats context "property_search" is not set.');
    }

    const categoryAdapter = new Snowplow2StatsAdapterCategory(this.context.global.property_search.category);

    const schema: Snowplow2StatsSchemaSearchContextInterface = {
      schema: 'iglu:ae.propertyfinder/search_context/jsonschema/1-0-1',
      data: {
        category: categoryAdapter.getData(),
      },
    };

    // Property type
    if (this.context.global.property_search.property_type_id !== undefined) {
      schema.data.property_type_id = this.context.global.property_search.property_type_id;
    }

    // Price min
    if (this.context.global.property_search.price_min !== undefined) {
      schema.data.min_price = this.context.global.property_search.price_min;
    }

    // Price max
    if (this.context.global.property_search.price_max !== undefined) {
      schema.data.max_price = this.context.global.property_search.price_max;
    }

    // Bedrooms min
    if (this.context.global.property_search.bedroom_min !== undefined) {
      schema.data.min_bedrooms = this.context.global.property_search.bedroom_min;
    }

    // Bedrooms max
    if (this.context.global.property_search.bedroom_max !== undefined) {
      schema.data.max_bedrooms = this.context.global.property_search.bedroom_max;
    }

    // Area min
    if (this.context.global.property_search.area_min !== undefined) {
      schema.data.min_area = this.context.global.property_search.area_min;
    }

    // Area max
    if (this.context.global.property_search.area_max !== undefined) {
      schema.data.max_area = this.context.global.property_search.area_max;
    }

    // Keywords
    if (this.context.global.property_search.keywords !== undefined) {
      schema.data.keywords = this.context.global.property_search.keywords;
    }

    // Locations
    if (this.context.global.property_search.locations !== undefined) {
      schema.data.locations = this.context.global.property_search.locations;
    }

    // Amenities
    if (this.context.global.property_search.amenities !== undefined) {
      schema.data.amenities = this.context.global.property_search.amenities;
    }

    // Furnishings
    if (this.context.global.property_search.furnished !== undefined) {
      const furnishingsAdapter = new Snowplow2StatsAdapterFurnishings(
        String(this.context.global.property_search.furnished)
      );

      schema.data.furnishings = furnishingsAdapter.getData();
    }

    // Price period
    if (this.context.global.property_search.rental_period !== undefined) {
      const rentalPeriodAdapter = new Snowplow2StatsAdapterPricePeriod(
        this.context.global.property_search.rental_period
      );

      schema.data.price_period = rentalPeriodAdapter.getData();
    }

    // Is developer property
    if (this.context.global.property_search.is_developer_property !== undefined) {
      schema.data.is_developer_property = this.context.global.property_search.is_developer_property === '1';
    }

    // Min installment years
    if (this.context.global.property_search.min_installment_years !== undefined) {
      schema.data.min_installment_years = this.context.global.property_search.min_installment_years;
    }

    // Max installment years
    if (this.context.global.property_search.max_installment_years !== undefined) {
      schema.data.max_installment_years = this.context.global.property_search.max_installment_years;
    }

    // Sorting
    if (this.context.global.property_search.sort !== undefined) {
      schema.data.sort = this.context.global.property_search.sort;
    }

    // Bathrooms min
    if (this.context.global.property_search.bathroom_min !== undefined) {
      schema.data.min_bathrooms = this.context.global.property_search.bathroom_min;
    }

    // Bathrooms max
    if (this.context.global.property_search.bathroom_max !== undefined) {
      schema.data.max_bathrooms = this.context.global.property_search.bathroom_max;
    }

    // Completion status
    if (this.context.global.property_search.completion_status !== undefined) {
      schema.data.completion_status = this.context.global.property_search.completion_status;
    }

    // Virtual Viewings
    if (this.context.global.property_search.virtual_viewings !== undefined) {
      schema.data.virtual_viewings = this.context.global.property_search.virtual_viewings;
    }

    // Count
    if (this.context.local.pagination?.itemTotal !== undefined) {
      schema.data.search_result_count = this.context.local.pagination.itemTotal;
    }

    return schema;
  }
}
